<template>
  <Navbar :rightBtn="true" :title="'我的订单'"></Navbar>
  <van-empty description="暂无数据" v-show="emptyShow" />
  <van-list v-model:loading="loading" :finished="finished" finished-text="没有更多了" @load="getData" v-if="!emptyShow">
    <div class="policy-file-item" v-for="record in list" :key="record" @click="goDetail(record)">
      <!-- <list-item :record="record"></list-item> -->
       <div class="policy-file-item-content">
          <div class="policy-file-item-title">政策申报咨询服务</div>
          <div class="policy-file-item" v-if="record.sn">订单编号:{{ record.sn }}</div>
          <div class="policy-file-item" v-if="record.order_record && record.order_record.remarks">{{ record.order_record.remarks }}</div>
        </div>
      <div class="policy-file-item-footer">
        <div>
          <div v-if="record.modify_time">{{ record.modify_time }}</div>
          <div><span class="company-box" v-if="record.provider &&  record.provider.name">{{ record.provider.name }}</span></div>
        </div>
        <div class="declare-btn-box">
          <van-button class="declare-btn" type="primary" plain hairline  v-if="record.status == '1'">已完结
          </van-button>
          <van-button class="declare-btn" type="danger" v-else-if="record.status == '2'">异常
          </van-button>
          <van-button class="declare-btn" type="primary" v-else-if="record.status == '0'">进行中
            
          </van-button>
        </div>
      </div>
    </div>

  </van-list>
</template>
<script>
import { getOrdersBySpec } from "@/api/home"
import Navbar from '@/components/Navbar'
import ListItem from '@/components/ListItem.vue'

import { clickUrl,clickUrlToPhone } from '@/utils'
import store from '@/store'
export default {
  name: 'Order',
  data() {

    return {
      list: [],
      loading: false,
      finished: false,
      emptyShow: false,
      page:{
        count: 0,
        size: 20,
        total: 0
      },
    }
  },
  components: { Navbar, ListItem },
  computed: {},

  mounted() {},
  watch: {},
  methods: {
    goDetail(item) {
      clickUrl('/order/detail', { id: item.id, btnType: '2' })
    },
    async getData() {
      this.page.count += 1
      this.loading = true
      try{
      let res = await getOrdersBySpec()
      // let list = res.result.data.map((item) => {
      //   let arr = []
      //   if(item.policyId){
      //   arr.push(item.policy.dispatchDepartment)
      //   let moneyScopeMin = item.policy.moneyScopeMin ?item.policy.moneyScopeMin:0
      //   let moneyScopeMax = item.policy.moneyScopeMax ?item.policy.moneyScopeMax:0
      //   // arr.push('资金扶持:' + moneyScopeMin + '-' + moneyScopeMax + '万')
      //   arr.push('资金扶持')
      //   }
      //   return {
      //     ...item,
      //     policyTitle: item.policyId ? item.policy.policyTitle : item.serviceProvider.industry,
      //     policyTopic: arr
      //   }
      // }) || []
      let list = res.result.data || []
      this.list = this.list.concat(list)
      this.page.total = res.result.total
      this.finished = this.list.length >= res.result.total && res.result.total != 0 ? true : false
      this.emptyShow = !res.result.total ? true : false
      }catch{

      }finally{
        this.loading = false
      }
    },
  },
   beforeRouteEnter(to, from, next) {
    // 进来的时候添加缓存组件 name
    // 此时不能使用this.$store.commit 因为组件还没有被创建所以不能使用this
    store.commit('ADD_KEEP_ALIVE_COM', 'Order');
    next();
  },
  beforeRouteLeave(to, from, next) {
    // 离开的时候，非以下页面则删除缓存组件 name
    // 记录路由处的name值 (去往详情展示页面需要添加缓存)
    let coms = ['OrderDetail'];
    console.log(coms.indexOf(to.name) === -1, to.name);
    if (coms.indexOf(to.name) === -1) {
      store.commit('REMOVE_KEEP_ALIVE_COM', 'Order');
    }
    next();
  }
}
</script>

<style lang="scss" scoped>
.float-action {
  width: 100%;
  height: 60px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  background: #fff;
  z-index: 100;
  left: 0;
  bottom: 0;
  right: 0;
}

.float-action.transparent {
  background: transparent;
}

.float-action>div {
  flex: 1;
}

.float-action>div:last-child {
  flex: 2;
}

.flex-item .btn {
  width: 100%;
  height: 60px;
}

.company-box{
  display: inline-block;
  padding: 3px 5px;
  border: 1px solid #1989fa;
  color: #1989fa;
  margin-top: 5px;
}
</style>
